import { ApiError } from './types';

/**
 * Whether a failed write may have committed on the server (`.forge/plans/F5-h/F5-h-Wave-2-contract.md`
 * § Behaviour Rules, "A failure that is not a refusal"; F5-h WI-2.2 plan Decision 3).
 *
 * - **Known — nothing was committed:** an `ApiError` below `500` (a refusal: every `4xx`, the `401`
 *   included), or a `5xx` that carries a problem envelope (the server's own answer: the transaction
 *   rolled back).
 * - **Unknown — the server may have committed:** anything else. A network failure (`fetch` rejects with a
 *   `TypeError` after the request may have been sent), an `ApiContractError` (a `2xx` whose body did not
 *   narrow, so the server did commit), or a `5xx` with no envelope (a proxy's answer, which can arrive
 *   after a commit).
 *
 * `apiClient` turns every non-`2xx` response into an `ApiError`, with `problem` `undefined` when the body
 * is not an envelope, so `problem` is what tells the server's `5xx` from a proxy's. One rule for every
 * caller — the Change owner pass, the Change manager pass and F32-c's reuse of the bulk step — so they
 * cannot drift apart.
 */
export function isWriteOutcomeUnknown(error: unknown): boolean {
    if (!(error instanceof ApiError)) {
        return true;
    }
    return error.status >= 500 && error.problem === undefined;
}
